import React from 'react';

import { PERFORM_APPLICATION_ACTION } from '@applicant-flow/graphql';
import { RejectionDrawer, RejectionDrawerValues } from '@common/components';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';

export const ApplicationRejectionDrawer = ({
  applicationId,
  open,
  onClose,
}: {
  applicationId?: string | null;
  open: boolean;
  onClose: () => void;
}) => {
  function errorMessage() {
    createMessage(
      'error',
      'Failed to change application state. Please try again.'
    );
  }

  const [performAction, { loading }] = useMutation(PERFORM_APPLICATION_ACTION, {
    refetchQueries: [
      'MissionControlPaginatedStaffingRequestApplications',
      'MissionControlStaffingRequestCounters',
    ],
    onCompleted: (data) => {
      if (!data || !data.performApplicationAction) {
        errorMessage();
        return;
      }
      createMessage('success', 'Application status successfully changed');
      onClose();
    },
    onError: errorMessage,
  });

  const onRejectClick = (input: RejectionDrawerValues) => {
    if (!applicationId) return;

    performAction({
      variables: {
        staffingRequestApplicationId: applicationId,
        input: {
          action: 'reject',
          reason: input.rejectionReason,
          rejectionDetails: input.rejectionComment,
        },
      },
    });
  };

  return (
    <RejectionDrawer
      onClose={onClose}
      onRejectClick={onRejectClick}
      title="Reject Candidate Application"
      visible={open}
      reasonsListQuery="StaffingRequestApplicationRejectionReasonsInputs"
      loading={loading}
    />
  );
};
